import withModal from 'lib/helpers/hoc/withModal'
import Step3ApiInfo from '../new-api-modal/steps/Step3ApiInfo'
import Step2Headers from '../new-api-modal/steps/Step2Headers'
import Label from 'components/atoms/input/input-label/InputLabel'
import { useTranslation } from 'react-i18next'

const ViewApiModal = ({ data, headers }: any) => {

    const { t } = useTranslation()

    return (
        <div className='space-y-5'>
            
            <div>
                <Label>{t('Fields Overview')}</Label>
                <Step2Headers Headers={data.module === 'Lead' ? headers.lead_headers : headers.app_headers} />
            </div>
            <div>
                <Label>{t('View Access Details')}</Label>
                <Step3ApiInfo ApiInfo={data} />
            </div>
        </div>
    )
}

export default withModal(ViewApiModal)